import { WhatsAppFormattedText } from '~/features/whatsapp/components/WhatsAppFormattedText';
import { getVisibleChatMediaCaption } from '~/features/whatsapp/utils/resolveChatAttachmentDownloadName';

type Props = {
    quoted: { content: string | null; header?: string | null; mediaFileName?: string | null };
};

// Full size/colour, not clamped — a greyed quote is unreadable. Display-only.
export const QuotedMessage = ({ quoted }: Props) => {
    const text = getVisibleChatMediaCaption(quoted.content) || quoted.mediaFileName;
    if (!text && !quoted.header) return null;

    return (
        <div
            className="mb-2 rounded border-l-4 border-blue bg-white px-2 py-1.5 text-midnight"
            data-testid="quoted-message"
        >
            {quoted.header && (
                <div className="mb-1 whitespace-pre-wrap break-words font-semibold">
                    <WhatsAppFormattedText text={quoted.header} />
                </div>
            )}
            {text && (
                <div className="whitespace-pre-wrap break-words">
                    <WhatsAppFormattedText text={text} />
                </div>
            )}
        </div>
    );
};
